// extracted by mini-css-extract-plugin
module.exports = {"claimListContainer":"_23ji4hhR4DEPLfaerwM0dc","campaignKey":"_167Ui65bdl9Me1-aU19Hfv"};